/** Top-right offer on every plan card. Same copy and size everywhere. */
export function PlanOfferBadge() {
  return (
    <div className="absolute top-0 right-0 z-[1] bg-sand text-white px-3 py-2 rounded-bl-radius text-right leading-tight">
      <p className="text-sm sm:text-base font-semibold">
        Limited{' '}
        <span className="text-teal font-heading text-xl sm:text-2xl font-bold align-middle">30%</span>
        {' '}off
      </p>
    </div>
  );
}

export function isMostPopularPlan(index: number) {
  return index === 1;
}

export function PlanPopularBadge() {
  return (
    <div className="absolute top-0 left-0 z-[1] bg-teal text-white text-xs font-semibold px-3 py-1 rounded-br-radius-sm">
      Most popular
    </div>
  );
}
